<script>
    import { Link, navigate } from 'svelte-routing';
    import { token } from '../stores.js';

    import { fade } from 'svelte/transition';

    export let userdata;
    console.log(userdata);

    let warning = false;

	let result = null

    async function fetchData() {
        const res = await fetch( userdata['base_path'] + 'assets/php/auth.php', {
			method: 'POST',
			body: JSON.stringify(userdata)
		})

        if (res.ok) {
            const json = await res.json()
		    result = JSON.stringify(json);
            console.log(json);

            if (json.state == true) {
                localStorage.setItem('token', '1');
                localStorage.setItem('user_role', json.user_role);
                localStorage.setItem('user_name', json.user_name);
                token.set(localStorage.getItem('token'));
                navigate('/admin', { replace: true });
            }

            else {
                // navigate('/', { replace: true });
                console.log(json.error);
            }

            
            
            
        } else {
            throw new Error(data);
        }
		
		

        



  }
</script>
    <main in:fade={{ delay: 500, duration: 1000 }}> 
        <img src="../../assets/images/woow-logo-black.svg" alt="logo">
    <h1>👋 Welcome</h1>
        
            <Link to="tour">Go to Tour</Link>
            <span>or</span>
            <Link class="big" to="login">Go to Admin</Link>
        
    </main>    
<style lang="scss">
    main {
        position: absolute;
        top: 50%;
        left: 50%;
        transform:translate(-50%, -50%);
        width: 300px;
        height: auto;
        margin: auto;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 100px 32px;
        border-radius: 8px;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    }

    span {
        margin: 16px auto;
    }

    @media only screen and (max-width: 680px) {
        main {
            width: 80%;
            height: 90%;
            padding: 0px;

            img {
                width: 75%;
                height: auto;
                
            }
        }
    }


</style>